import { PaymentCardResponse } from './payment-card-response.model';

// do not expose this model outside of payment form, only used within the payment iframe component
export class PaymentDataResponse {
    public email: string;
    public shippingCountry: string;
    public name: string;
    public cardToken: string;
    public customerId: string;
    public reference: string;
    public card: PaymentCardResponse;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/payment-data-response.model.ts